// src/components/RequireAdmin.jsx
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from './AuthContext';
import EmojiLoader from './EmojiLoader';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function RequireAdmin({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let active = true;

    async function check() {
      // Precisa estar logado
      if (!user?.token) {
        if (active) setState({ loading: false, allowed: false });
        return;
      }

      // Se já veio marcado como admin, nem consulta
      if (user.role === 'admin') {
        if (active) setState({ loading: false, allowed: true });
        return;
      }

      // Se veio sem role (ou diferente), confirma no backend
      try {
        const { data } = await axios.get(`${API_BASE}/api/me`, {
          headers: { Authorization: `Bearer ${user.token}` },
          params: { t: Date.now() }, // evita cache
        });
        const isAdmin = data?.role === 'admin';
        if (active) setState({ loading: false, allowed: isAdmin });
      } catch (e) {
        console.error('RequireAdmin: falha ao checar /api/me', e);
        if (active) setState({ loading: false, allowed: false });
      }
    }

    check();
    return () => { active = false; };
  }, [user?.token, user?.role]);

  // Não logado → vai pro /login
  if (!user) return <Navigate to="/login" replace />;

  // Checando role → mostra um loader
  if (state.loading) return <EmojiLoader />;

  // Se admin → libera; senão → manda pro /dashboard
  return state.allowed ? children : <Navigate to="/dashboard" replace />;
}